
  import Swiper, { Navigation, Thumbs } from "swiper";
  Swiper.use([Navigation, Thumbs]);
  import { followuser } from "@/views/post/api/index";
  declare global {
  interface Window {
    sy: any;
  }
}
  class Post {
    constructor() {
      this.init();
      this.bindEvents();
    }
    init() {
      const galleryThumbs = new Swiper(".gallery-thumbs", {
        spaceBetween: 20,
        slidesPerView: 8,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      });
      new Swiper(".gallery-top", {
        loop: true,
        spaceBetween: 0,
        width: 670,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: galleryThumbs,
        },
      });
    }
    handleUrl(url: string) {
      if (url === '') return {}
      const options: any = {}
      let name
      let value
      const paramsStart = url.indexOf('?') + 1
      const paramsEnd = url.indexOf('#') === -1 ? url.length : url.indexOf('#')
      const str = url.slice(paramsStart, paramsEnd)
      const arrtmp = str.split('&')
      for (let i = 0, len = arrtmp.length; i < len; i++) {
        const paramCount = arrtmp[i].indexOf('=')
        if (paramCount > 0) {
          name = arrtmp[i].substring(0, paramCount)
          value = arrtmp[i].substr(paramCount + 1)
          try {
            if (value.indexOf('+') > -1) value = value.replace(/\+/g, ' ')
            options[name] = decodeURIComponent(value)
          } catch (exp) { 
            console.log(exp)
          }
        }
      }
      delete options['frm']
      return options
    }
    bindEvents() {
      // const self = this
      document
        .querySelector("#followUser")
        ?.addEventListener("click", function(e: any) {
          if (e.target.dataset.uid && e.target.dataset.fid) {
            const uid = e.target.dataset.uid;
            const fid = e.target.dataset.fid;
            const flag = e.target.dataset.flag ? e.target.dataset.flag : 1;
            followuser({
              uid: uid, // 登陆用户
              fid: fid, // 帖子用户
              flag: flag,
            }).then((res: any) => {
              if (+res.code === 100) {
                if (+flag === 1) {
                  e.target.className = "btn follow-btn followed";
                  e.target.innerText = "已关注";
                  e.target.dataset.flag = 2;
                } else {
                  e.target.className = "btn follow-btn";
                  e.target.innerText = "关注";
                  e.target.dataset.flag = 1;
                }
              } else {
                window.alert(res.msg);
              }
            });
          } else {
            window.sy.login.popup();
          }
        });
      document
         .querySelectorAll("topic_at").forEach((dom)=> {
        dom.addEventListener("click", (e: any) => {
          const pramas: any = this.handleUrl(
            e.currentTarget.attributes.href.value
          );
          console.log("pramas", pramas);
          const tag_id = pramas.tag_id;
          window.location.href = `/group${tag_id}`;
        });
      });
      document
        .querySelectorAll("user_at").forEach((dom)=> {
           dom.addEventListener("click", (e: any) => {
            const pramas: any = this.handleUrl(
              e.currentTarget.attributes.href.value
            );
            let url = "";
            const uid = pramas.uid;
            const certified_type = +pramas.certified_type || "";
            const certified_id = pramas.certified_id || "";
            switch (certified_type) {
              case 0:
                url = `/u${uid}`;
                break;
              case 1:
                url = `/u${uid}`;
                break;
              case 2:
                url = `/hospital/${certified_id}/`;
                break;
              case 3:
                url = `/doctor/${certified_id}/zhuye/`;
                break;
              default:
                url = `/u${uid}`;
                break;
            }
            window.location.href = url;
          });
        });
      window.addEventListener('scroll', function (e: any) {
        const scrollH = document.body.scrollHeight;
        const windowH = window.innerHeight || document.documentElement.clientHeight;
        const ele = document.querySelector("#fixedRight");
        const scrollY = window.pageYOffset || window.scrollY;
        if (ele) {
          // if (window.pageYOffset + windowH + 670 >= scrollH) {
          // scrollY + window.innerHeight > scrollH - 715 + window.innerHeight - 680
          if (
            scrollY >
            scrollH - 715 - 700
          ) {
            ele.className = "post-right abs";
          } else {
            ele.className = "post-right";
          }
        }
      })
      const leftBtn = document.querySelector("#cardSwiperLeftBtn") || null;
      const rightBtn = document.querySelector("#cardSwiperRightBtn") || null;
      const scrollArea = document.querySelector("#scrollArea") || null;
      const scrollAreaWidth = scrollArea ? scrollArea.scrollWidth : 0;

      if (leftBtn && rightBtn) {
        leftBtn.addEventListener('click', ()=> {
          leftBtn.className = "left-btn dis";
          rightBtn.className = "right-btn";
          scrollArea?.scrollTo(0, 0);
        })
        rightBtn.addEventListener("click", () => {
          leftBtn.className = "left-btn";
          rightBtn.className = "right-btn dis";
          scrollArea?.scrollTo(scrollAreaWidth, 0);
        }); 
      }
    }
  }

export const post = new Post();